import debounce from '../plugins/debounce';

export default () => {
  let selectedCountry = [];
  let selectedRespondent = [];
  let selectedOrganisation = [];
  let searchText = '';

  const perLoad = 20;
  let offset = 0;

  let showingResults = false; // Om resultat visas i tabellen
  let loading = false; // Om resultat laddas
  let hasText = false // Om sökfältet innehåller text

  const scrollCheck = () => {
    if($(window).scrollTop() + $(window).height() >= ($(window).height() - ($('#survey-table-body').offset().top - $('#survey-table-body').height()) - 200) &&
       showingResults && !loading) {
      startLoading('small');
      offset = offset+perLoad;
      $.post(
        horizon.ajaxUrl,
        {
          action: 'nobox_filter_table',
          country: selectedCountry.join(),
          respondent: selectedRespondent.join(),
          organisation: selectedOrganisation.join(),
          search: searchText,
          offset: offset,
          perLoad: perLoad,
        },
        (data, response) => {
          if (response === 'success') {
            $('#survey-table-body').append(data.result);
            if(data.status) {
              showingResults = true;
            } else {
              showingResults = false;
            }
            stopLoading('small');
          }
        }
      );
    }
  };
  document.addEventListener('scroll', debounce(scrollCheck, 250), {
    capture: false,
    passive: true,
  });

  const fitler = (event) => {
    const id = event.currentTarget.id;

    switch(id) {
      case 'country':
        selectedCountry = $('#' + id).val();
        break;
      case 'respondent':
        selectedRespondent = $('#' + id).val();
        break;
      case 'organisation':
        selectedOrganisation = $('#' + id).val();
        break;
      default:
        selectedCountry = '';
        selectedRespondent = '';
        selectedOrganisation = '';
        break;
    }

    startLoading();
    $.post(
      horizon.ajaxUrl,
      {
          action: 'nobox_filter_table',
          country: selectedCountry.join(),
          respondent: selectedRespondent.join(),
          organisation: selectedOrganisation.join(),
          search: searchText,
          id: horizon.pageId,
      },
      (data, response) => {
        if (response === 'success') {
          $('#survey-table-body').html(data.result);
          if(data.status) {
            showingResults = true;
          } else {
            showingResults = false;
          }
        }
      }
    );
    filterFilters(id);
  };
  $('.select-filter').on('change', debounce(fitler, 250));

  const search = (event) => {
    searchText = event.currentTarget.value;

    if(searchText.length === 0) {
      hasText = false;
    } else {
      hasText = true;
    }

    toggleButton(hasText);

    if((searchText.length === 0 || !searchText || searchText === "") || searchText.length > 2) {
      startLoading('search');
      event.currentTarget.parentElement.classList.remove('error');
      $.post(
        horizon.ajaxUrl,
        {
            action: 'nobox_filter_table',
            country: selectedCountry.join(),
            respondent: selectedRespondent.join(),
            organisation: selectedOrganisation.join(),
            search: searchText,
            id: horizon.pageId,
        },
        (data, response) => {
          if (response === 'success') {
            $('#survey-table-body').html(data.result);
            if(data.status) {
              showingResults = true;
            } else {
              showingResults = false;
            }
          }
          stopLoading('search');
        }
      );
    } else {
      event.currentTarget.parentElement.classList.add('error');
    }
  };
  $('#survey-search').on('input', debounce(search, 250));
  $('#clear-search').on('click', e => {
    $('#survey-search').val('');
    const fakeEvent = {
      currentTarget: {
        value: '',
        parentElement: document.getElementById('survey-search').parentElement,
      }
    }
    search(fakeEvent);
  });

  async function filterFilters(id = '') {
    await $.post(
      horizon.ajaxUrl,
      {
          action: 'nobox_filter_filters',
          country: selectedCountry.join(),
          respondent: selectedRespondent.join(),
          organisation: selectedOrganisation.join(),
      },
      (data, response) => {
        if (response === 'success') {
          if(id !== 'country') {
            $('#country').html('');
            data.countries.forEach(country => {
              if(country.country) {
                const opt = document.createElement('option');
                $(opt).addClass(country.c == 0 ? 'empty' : '');
                $(opt).val(country.country);
                $(opt).text(country.country + ' (' + country.c + ')');
                if(selectedCountry.includes(country.country)) {
                  $(opt).attr('selected', '');
                }
                $('#country').append(opt);
              }
            });
            document.getElementById('country').dispatchEvent(new Event('loadOptions'));
          }

          if(id !== 'respondent') {
            $('#respondent').html('');
            data.respondents.forEach(respondent => {
              if(respondent.respondent) {
                const opt = document.createElement('option');
                $(opt).addClass(respondent.c == 0 ? 'empty' : '');
                $(opt).val(respondent.respondent);
                $(opt).text(respondent.respondent + ' (' + respondent.c + ')');
                if(selectedRespondent.includes(respondent.respondent)) {
                  $(opt).attr('selected', '');
                }
                $('#respondent').append(opt);
              }
            });
            document.getElementById('respondent').dispatchEvent(new Event('loadOptions'));
          }

          if(id !== 'organisation') {
            $('#organisation').html('');
            data.organisations.forEach(organisation => {
              if(organisation.organisation) {
                const opt = document.createElement('option');
                $(opt).addClass(organisation.c == 0 ? 'empty' : '');
                $(opt).val(organisation.organisation);
                $(opt).text(organisation.organisation + ' (' + organisation.c + ')');
                if(selectedOrganisation.includes(organisation.organisation)) {
                  $(opt).attr('selected', '');
                }
                $('#organisation').append(opt);
              }
            });
            document.getElementById('organisation').dispatchEvent(new Event('loadOptions'));
          }

          stopLoading();
        }
      }
    );
  }

  startLoading();
  filterFilters();

  function startLoading(size = 'big') {
    // console.log('start')
    loading = true;
    document.querySelector('.loading-wrapper.' + size).style.display = 'block';
  }
  function stopLoading(size = 'big') {
    // console.log('stop')
    loading = false;
    document.querySelector('.loading-wrapper.' + size).style.display = 'none';
  }
  function toggleButton(show) {
    if(show) {
      $('#clear-search').addClass('active');
    } else {
      $('#clear-search').removeClass('active');
    }
  }
};
